import {isStatic} from './isStatic';
import {isSticker} from './isSticker';
import type {Post} from '../types';

export function isStaticImage(gif: Post): boolean {
    return isStatic(gif) && !isSticker(gif);
}
